import { useEffect, useRef } from "react";
import { confirmable, createConfirmation } from "react-confirm";
import { Modal } from "../Modal.tsx";
import { range } from "../../../../../common/utils.ts";
import { Flag } from "../WatchBlock.tsx";
import i18n from "../../util/i18n.ts";

const Confirm = confirmable<
	{
		numPlayers: number;
		numWatchColors: number;
	},
	number | null
>(({ show, proceed, numPlayers, numWatchColors }) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.select();
		}
	}, []);

	const cancel = () => proceed(null);

	return (
		<Modal animation show={show} onHide={cancel}>
			<Modal.Body
				data-watch-list-dialog=""
				data-watch-list-dialog-color-count={numWatchColors}
				data-watch-list-dialog-player-count={numPlayers}
			>
				<h3>
					{i18n.t("watchList.chooseFollowMarker", {
						ns: "ui",
						count: numPlayers,
						defaultValue: "Choose a follow marker for {{count}} selected player",
					})}
				</h3>
				<div className="d-flex flex-wrap gap-2">
					{range(numWatchColors + 1).map((watch) => {
						return (
							<button
								key={watch}
								className="btn btn-light"
								data-watch-list-choice={watch}
								onClick={() => {
									proceed(watch);
								}}
							>
								{watch === 0 ? i18n.t("watchList.clear", { ns: "ui", defaultValue: "Clear" }) : watch}{" "}
								<Flag watch={watch} />
							</button>
						);
					})}
				</div>
			</Modal.Body>

			<Modal.Footer>
				<button
					className="btn btn-secondary"
					data-watch-list-dialog-cancel=""
					onClick={cancel}
				>
					{i18n.t("common.cancel", { ns: "ui", defaultValue: "Cancel" })}
				</button>
			</Modal.Footer>
		</Modal>
	);
});

const confirmFunction = createConfirmation(Confirm);

export const watchListDialog = (arg: {
	numPlayers: number;
	numWatchColors: number;
}) => {
	return confirmFunction(arg);
};
